import { application } from "./application"
import { identifierForGlobKey } from "stimulus-vite-helpers"

const controllerModules = import.meta.glob("./**/*_controller.js")
const controllers = new Map(Object.entries(controllerModules).map(([path, load]) => [identifierForGlobKey(path), load]))
const loading = new Map()

document.addEventListener("turbo:load", () => {
  const identifiers = new Set(Array.from(document.querySelectorAll("[data-controller]"), (element) => element.dataset.controller.split(/\s+/)).flat())

  identifiers.forEach((identifier) => {
    const load = controllers.get(identifier)
    if (!load || loading.has(identifier)) return

    // ponytail: controllers are discovered on each Turbo page load; add a MutationObserver only if controllers start appearing between navigations.
    loading.set(identifier, load().then((module) => application.register(identifier, module.default)))
  })
})
